<header class="app-topbar">
  <div class="page-container topbar-menu">
    <div class="d-flex align-items-center gap-2">
      <app-logo-box />
      <!-- Sidebar Menu Toggle Button -->
      <button class="sidenav-toggle-button px-2" (click)="toggleMobileMenu()">
        <i class="ri-menu-5-line fs-24"></i>
      </button>

      <!-- Horizontal Menu Toggle Button -->
      <button
        class="topnav-toggle-button px-2"
        (click)="toggleMobileMenu()"
        data-bs-toggle="collapse"
        data-bs-target="#topnav-menu-content"
      >
        <i class="ri-menu-5-line fs-24"></i>
      </button>

      <div class="topbar-item d-none d-md-flex">
        @if (subTitle) {
          <div>
            <h4 class="page-title fs-18 fw-bold mb-0">{{ title }}</h4>
            <ol class="breadcrumb m-0 mt-1 py-0">
              <li class="breadcrumb-item">
                <a href="javascript: void(0);">RedFin</a>
              </li>
              <li class="breadcrumb-item active">{{ subTitle }}</li>
            </ol>
          </div>
        } @else {
          <h4 class="page-title fs-18 fw-bold mb-0">{{ title }}</h4>
        }
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <div class="topbar-item d-flex d-xl-none">
        <button
          class="topbar-link"
          data-bs-toggle="modal"
          data-bs-target="#searchModal"
          type="button"
        >
          <i class="ri-search-line fs-22"></i>
        </button>
      </div>

      <div class="topbar-item d-none d-sm-flex">
        <button class="topbar-link" (click)="settingMenu()" type="button">
          <i class="ri-settings-4-line fs-22"></i>
        </button>
      </div>

      <div class="topbar-item d-none d-sm-flex">
        <button
          class="topbar-link"
          (click)="changeTheme()"
          id="light-dark-mode"
          type="button"
        >
          @if (color === 'light') {
            <i class="ri-moon-line fs-22"></i>
          } @else {
            <i class="ri-moon-line fs-22"></i>
          }
        </button>
      </div>

      <div class="topbar-item nav-user">
        <div class="dropdown" ngbDropdown>
          <a
            ngbDropdownToggle
            class="topbar-link drop-arrow-none px-2"
            data-bs-toggle="dropdown"
            data-bs-offset="0,19"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <img
              [src]="currentUser?.imageUrl"
              width="32"
              class="rounded-circle me-lg-2 d-flex"
              alt="user-image"
            />
            <span class="d-lg-flex flex-column gap-1 d-none">
              <h5 class="my-0">{{ currentUser?.person?.name }}</h5>
            </span>
            <i
              class="ri-arrow-down-s-line d-none d-lg-block align-middle ms-2"
            ></i>
          </a>
          <div ngbDropdownMenu class="dropdown-menu-end">
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">¡Bienvenido!</h6>
            </div>

            <a
              (click)="logout()"
              class="cursor-pointer dropdown-item active fw-semibold text-danger"
            >
              <i class="ri-logout-box-line me-1 fs-16 align-middle"></i>
              <span class="align-middle">Cerrar sesión</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<ng-template #content let-modal>
  <div class="card mb-0 w-100">
    <div class="px-3 py-2 d-flex flex-row align-items-center" id="top-search">
      <i class="ti ti-search fs-22"></i>
      <input
        type="search"
        class="form-control border-0"
        id="search-modal-input"
        placeholder="Search for actions, people,"
      />
      <button
        type="button"
        class="btn p-0"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        [esc]
      </button>
    </div>
  </div>
</ng-template>
